var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCaiDat = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.5714C0 12.7919 12.7919 0 28.5714 0H71.4286C87.2081 0 100 12.7919 100 28.5714V71.4286C100 87.2081 87.2081 100 71.4286 100H28.5714C12.7919 100 0 87.2081 0 71.4286V28.5714Z",
    fill: "#6093EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 58.0355C54.4381 58.0355 58.0358 54.4378 58.0358 49.9998C58.0358 45.5618 54.4381 41.9641 50.0001 41.9641C45.5621 41.9641 41.9644 45.5618 41.9644 49.9998C41.9644 54.4378 45.5621 58.0355 50.0001 58.0355Z",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2144 52.3567V47.6424C23.2144 44.8567 25.4911 42.5531 28.3036 42.5531C33.1519 42.5531 35.134 39.1246 32.6965 34.9192C31.3036 32.5085 32.134 29.3746 34.5715 27.9817L39.2054 25.3299C41.3215 24.071 44.0536 24.821 45.3126 26.9371L45.6072 27.446C48.0179 31.6514 51.9822 31.6514 54.4197 27.446L54.7144 26.9371C55.9733 24.821 58.7054 24.071 60.8215 25.3299L65.4554 27.9817C67.8929 29.3746 68.7233 32.5085 67.3304 34.9192C64.8929 39.1246 66.8751 42.5531 71.7233 42.5531C74.509 42.5531 76.8126 44.8299 76.8126 47.6424V52.3567C76.8126 55.1424 74.5358 57.446 71.7233 57.446C66.8751 57.446 64.8929 60.8746 67.3304 65.0799C68.7233 67.5174 67.8929 70.6246 65.4554 72.0174L60.8215 74.6692C58.7054 75.9281 55.9733 75.1781 54.7144 73.0621L54.4197 72.5531C52.009 68.3478 48.0447 68.3478 45.6072 72.5531L45.3126 73.0621C44.0536 75.1781 41.3215 75.9281 39.2054 74.6692L34.5715 72.0174C32.134 70.6246 31.3036 67.4906 32.6965 65.0799C35.134 60.8746 33.1519 57.446 28.3036 57.446C25.4911 57.446 23.2144 55.1424 23.2144 52.3567Z",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_449_888",
    x1: 43.93,
    y1: 5.09124e-7,
    x2: 43.93,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#689DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948917,
    stopColor: "#3967DE"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCaiDat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CaiDat.2d7c6cc8.svg";
export { ForwardRef as ReactComponent };